// extracted by mini-css-extract-plugin
export default {"row":"SettingModal_row__eGdIj","title":"SettingModal_title__Zu51B","desc":"SettingModal_desc__GSeoS"};